import { World } from '@ecs/World';
import { Entity } from '@ecs/Entity';
import { EntityFactory } from '@entities/EntityFactory';
import { Health } from '@components/Health';
import { RosterLink } from '@components/RosterLink';
import { MissionReport, RosterShip } from '@/fleet/Fleet';

/** A combat ship for a roster entry: its class, its carried-over hull and fresh shields. */
export function createRosterShipEntity(ship: RosterShip, x: number, y: number): Entity {
  const entity = EntityFactory.createPlayerShip(ship.shipClass, x, y);
  entity.getComponent(Health)!.current = Math.min(ship.hull, ship.maxHull);
  entity.addComponent(new RosterLink(ship.id, ship.name));
  return entity;
}

/** Reads which roster ships are still flying, and with how much hull, at the end of a mission. */
export function buildMissionReport(world: World, participants: number[], score: number, completed: boolean): MissionReport {
  const survivors = world.getEntitiesWithComponents(RosterLink, Health)
    .filter(e => !world.isPendingRemoval(e) && e.getComponent(Health)!.current > 0)
    .map(e => ({ id: e.getComponent(RosterLink)!.shipId, hull: e.getComponent(Health)!.current }))
    .filter(s => participants.includes(s.id));

  return { participants: [...participants], survivors, score, completed };
}
